export interface Category {
  id: number;
  name: string;
  slug: string;
  link: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    link: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20single%20pair%20of%20white%20leather%20sneakers%20placed%20on%20a%20smooth%20cream%20concrete%20surface%20with%20soft%20natural%20daylight%20casting%20gentle%20shadows%20from%20the%20left%2C%20warm%20neutral%20background%2C%20editorial%20fashion%20catalog%20style%2C%20clean%20elevated%20composition%20with%20generous%20negative%20space%2C%20no%20text%20no%20logos%20no%20busy%20elements&width=400&height=400&seq=cat-shoes-v2&orientation=squarish',
  },
  {
    id: 2,
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    link: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20premium%20oatmeal%20colored%20cotton%20hoodie%20neatly%20folded%20on%20a%20light%20warm%20beige%20linen%20backdrop%2C%20soft%20diffused%20natural%20light%20from%20above%2C%20minimal%20clean%20aesthetic%2C%20luxury%20lifestyle%20product%20photography%2C%20subtle%20fabric%20texture%20visible%2C%20no%20distracting%20elements%2C%20elegant%20simplicity&width=400&height=400&seq=cat-hoodies-v2&orientation=squarish',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    link: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Three%20pastel%20toned%20cotton%20t-shirts%20in%20sage%20green%20terracotta%20and%20cream%20folded%20in%20a%20tidy%20stack%20on%20a%20warm%20wooden%20surface%2C%20soft%20morning%20light%20streaming%20diagonally%2C%20clean%20minimal%20editorial%20style%2C%20fabric%20texture%20subtle%20and%20visible%2C%20neutral%20background%20with%20gentle%20warmth%2C%20no%20logos%20no%20text&width=400&height=400&seq=cat-tshirts-v2&orientation=squarish',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    link: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20olive%20green%20bomber%20jacket%20draped%20artfully%20over%20a%20minimal%20wooden%20hanger%20against%20a%20soft%20cream%20wall%2C%20indirect%20natural%20lighting%20creating%20subtle%20shadows%2C%20modern%20minimalist%20fashion%20product%20photography%2C%20clean%20composition%20emphasizing%20fabric%20drape%20and%20texture%2C%20warm%20neutral%20color%20palette&width=400&height=400&seq=cat-jackets-v2&orientation=squarish',
  },
  {
    id: 5,
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    link: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20light%20beige%20linen%20trousers%20and%20matching%20shorts%20arranged%20side%20by%20side%20on%20a%20smooth%20warm%20terracotta%20toned%20surface%2C%20soft%20overhead%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20clean%20lines%20and%20visible%20fabric%20weave%2C%20harmonious%20earth%20tone%20palette&width=400&height=400&seq=cat-pants-v2&orientation=squarish',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    link: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20cream%20colored%20baseball%20cap%20with%20a%20subtle%20curved%20brim%20resting%20on%20a%20clean%20light%20oak%20surface%2C%20soft%20natural%20side%20lighting%20casting%20gentle%20shadows%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20no%20visible%20branding%2C%20elegant%20simplicity%20with%20texture%20detail%20on%20fabric&width=400&height=400&seq=cat-headwear-v2&orientation=squarish',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    link: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20fashion%20set%20of%20matching%20sage%20green%20top%20and%20wide%20leg%20trousers%20artfully%20arranged%20on%20a%20warm%20cream%20backdrop%2C%20gentle%20natural%20light%20from%20left%20side%2C%20editorial%20minimalist%20lifestyle%20photography%2C%20clean%20composition%20with%20flowing%20fabric%20drape%2C%20soft%20earthy%20tones&width=400&height=400&seq=cat-sets-v2&orientation=squarish',
  },
  {
    id: 8,
    name: 'Underwear / Underpants',
    slug: 'underwear-underpants',
    link: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20organic%20cotton%20underwear%20in%20soft%20neutral%20earth%20tones%20arranged%20in%20a%20clean%20row%20on%20a%20light%20linen%20fabric%20surface%2C%20diffused%20natural%20overhead%20lighting%2C%20minimal%20elegant%20product%20photography%2C%20subtle%20texture%20emphasis%2C%20warm%20inviting%20aesthetic&width=400&height=400&seq=cat-underwear-v2&orientation=squarish',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    link: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20crisp%20white%20athletic%20jersey%20with%20subtle%20pinstripe%20detail%20draped%20on%20a%20minimal%20wooden%20hanger%20against%20a%20soft%20warm%20grey%20wall%2C%20natural%20window%20light%20from%20right%2C%20clean%20sporty%20editorial%20photography%2C%20fabric%20texture%20visible%2C%20elegant%20minimal%20composition%20with%20generous%20breathing%20room&width=400&height=400&seq=cat-jersey-v2&orientation=squarish',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    link: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Curated%20flat%20lay%20of%20elegant%20fashion%20accessories%20including%20a%20minimal%20watch%20a%20thin%20chain%20necklace%20and%20round%20sunglasses%20arranged%20on%20a%20warm%20sand%20colored%20surface%2C%20soft%20natural%20light%20with%20gentle%20shadows%2C%20editorial%20product%20photography%2C%20clean%20harmonious%20arrangement&width=400&height=400&seq=cat-accessories-v2&orientation=squarish',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    link: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20structured%20camel%20brown%20leather%20tote%20bag%20standing%20upright%20on%20a%20clean%20cream%20surface%20with%20soft%20natural%20daylight%20from%20left%2C%20minimalist%20product%20photography%2C%20elegant%20simplicity%2C%20visible%20leather%20grain%20texture%2C%20warm%20neutral%20palette%2C%20no%20distracting%20elements&width=400&height=400&seq=cat-bags-v2&orientation=squarish',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    link: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20handsome%20dark%20brown%20leather%20belt%20elegantly%20coiled%20in%20a%20circular%20arrangement%20on%20a%20smooth%20light%20oak%20tabletop%2C%20soft%20natural%20side%20lighting%20accentuating%20leather%20texture%20and%20brass%20buckle%2C%20minimal%20editorial%20product%20photography%2C%20warm%20aesthetic%2C%20clean%20elevated%20composition&width=400&height=400&seq=cat-belts-v2&orientation=squarish',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    link: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20elegant%20amber%20glass%20perfume%20bottle%20with%20minimal%20label%20standing%20on%20a%20warm%20cream%20marble%20surface%2C%20soft%20diffused%20natural%20light%20creating%20a%20gentle%20glow%20through%20the%20glass%2C%20luxury%20minimalist%20product%20photography%2C%20clean%20composition%20with%20subtle%20reflections%2C%20elegant%20sophisticated%20aesthetic&width=400&height=400&seq=cat-perfumes-v2&orientation=squarish',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    link: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20lifestyle%20flat%20lay%20with%20miscellaneous%20fashion%20items%20including%20a%20keychain%20a%20pair%20of%20socks%20and%20a%20small%20wallet%20arranged%20harmoniously%20on%20a%20warm%20terracotta%20colored%20surface%2C%20soft%20natural%20overhead%20light%2C%20editorial%20minimalist%20photography%2C%20clean%20balanced%20composition&width=400&height=400&seq=cat-other-v2&orientation=squarish',
  },
];